import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import {
    AssignedCurriculumProblemRepository,
    RequestGetProblemsByCurriculumIds,
    RequestGetProblemsByProblemIds,
} from "@/entities/assigned-curriculum-problem/domain/repository";
import type { GetAssignedCurriculumProblemsResponseDto } from "@/entities/assigned-curriculum-problem/domain/dtos";

@singleton()
export default class AssignedCurriculumProblemRepositoryImpl
    implements AssignedCurriculumProblemRepository
{
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    getAssignedCurriculumProblemsByCurriculumId = async (
        payload: RequestGetProblemsByCurriculumIds,
    ) => {
        let url = `/v1/assigned-curriculum-problems?`;

        // curriculumId query
        payload.curriculumIds.forEach((curriculumId) => {
            url += `curriculumId=${curriculumId}&`;
        });

        // timeDifficulty query
        payload.timeDifficulties.forEach((timeDifficulty) => {
            url += `timeDifficulty=${timeDifficulty}&`;
        });

        url += `size=${payload.size}&`;

        if (payload.nextToken) {
            url += `nextToken=${payload.nextToken}`;
        }

        const response = await this.server.get<GetAssignedCurriculumProblemsResponseDto>(url);

        return response;
    };

    getAssignedCurriculumProblemsByProblemId = async (payload: RequestGetProblemsByProblemIds) => {
        let url = `/v1/assigned-curriculum-problems?`;

        payload.problemIds.forEach((id) => {
            url += `problemId=${id}&`;
        });

        url += `size=${payload.size}`;

        if (payload.nextToken) {
            url += `nextToken=${payload.nextToken}`;
        }

        const response = await this.server.get<GetAssignedCurriculumProblemsResponseDto>(url);

        return response;
    };
}
